import React, { useState } from "react";
import { Group, Text, Menu, Switch } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function FilterVisibility({ options = [], values, onChange }) {
  const [opened, setOpened] = useState(false);
  if (!options.length) return null;

  const selectedValues = Array.isArray(values) ? values : ["all"];

  return (
    <Group
      position="apart"
      mx={5}
      p={5}
      sx={{ cursor: "pointer", borderRadius: 5, "&:hover": { backgroundColor: "#f3f3f3" } }}
      onClick={() => setOpened(!opened)}
    >
      <Text size="sm">Visibility</Text>
      <Menu
        // withinPortal={false}
        closeOnItemClick={false}
        opened={opened}
        zIndex={9999999}
        control={
          <Group spacing={4} style={{ width: 50 }} position="right">
            <FontAwesomeIcon icon={solid("chevron-right")} size="xs" color="grey" />
          </Group>
        }
        onClose={() => setOpened(false)}
        onOpen={() => setOpened(true)}
      >
        {options.map((item, key) => {
          const isSelected = selectedValues.includes(item.value);
          const isAll = selectedValues.includes("all");
          return (
            <Menu.Item key={key} onClick={(e) => e.stopPropagation()}>
              <Switch
                label={item.label}
                checked={isSelected || isAll}
                styles={{
                  input: { cursor: "pointer" },
                  label: { cursor: "pointer" },
                }}
                onChange={(e) => {
                  e.stopPropagation();
                  // event.currentTarget.checked
                  if (typeof onChange === "function") {
                    let newValues = ["all"];
                    if (isAll) {
                      newValues = options.filter(o => o.value !== item.value).map(v => v.value);
                    } else {
                      newValues = isSelected ? selectedValues.filter(value => value !== item.value) : [...selectedValues, item.value];
                    }
                    onChange(newValues);
                  }
                }}
              />
            </Menu.Item>
          );
        })}
      </Menu>
    </Group>
  );
}